import permissions from "../../data/permissions";

export default {
    path: "/accounting",
    component: () => import( "../../layouts/AccountingLayout.vue" ),
    meta: { requiresAuth: true, breadCrumb: "Accounting" },
    children: [
        {
            path: "journal-entry/:id",
            name: "JournalEntryDisplay",
            component: () => import( "../../views/accounting/JournalEntryDisplayView.vue" ),
            meta: { breadCrumb: "Journal Entry" },
        },
        {
            path: "journal-entry",
            name: "JournalEntry",
            component: () => import( "../../views/accounting/JournalEntries.vue" ),
            meta: { breadCrumb: "Journal Entry" },
        },
        {
            path: "exchange-rates",
            name: "ExchangeRates",
            component: () => import( "../../views/accounting/ExchangeRates.vue" ),
        },
        {
            path: "account-statements",
            name: "Statements",
            component: () => import( "../../views/accounting/Statements.vue" ),
            meta: { breadCrumb: "Account Statement" },
        },
        {
            path: "customer-balances",
            name: "CustomerBalance",
            component: () => import( "../../views/accounting/CustomerBalances.vue" ),
            meta: { breadCrumb: "Customer Balance" },
        },
        {
            path: "chart-of-accounts",
            name: "ChartOfAccounts",
            component: () => import( "../../views/accounting/ChartOfAccounts.vue" ),
            meta: { requiresAuth: true },
        },
        {
            path: "accounts",
            name: "AccountsList",
            component: () => import( "../../views/accounting/AccountsListView.vue" ),
            meta: { requiresAuth: true },
        },
        {
            path: "currencies",
            name: "Currencies",
            component: () => import( "../../views/accounting/Currencies.vue" ),
            meta: { requiresAuth: true },
        },
        {
            path: "dimensions",
            name: "Dimensions",
            component: () => import( "../../views/accounting/Dimensions.vue" ),
            meta: { requiresAuth: true },
        },
        {
            path: "bank-accounts",
            name: "BankAccounts",
            component: () => import( "../../views/accounting/BankAccounts.vue" ),
            meta: { requiresAuth: true },
        },
        {
            path: "trial-balance",
            component: () => import( "../../views/accounting/TrialBalance.vue" ),
            meta: { requiresAuth: true },
        },
        {
            path: "dimensions-report",
            component: () => import( "../../views/accounting/DimensionsReport.vue" ),
            meta: { requiresAuth: true },
        },
        {
            path: "transactions-export",
            component: () => import( "../../views/accounting/TransactionsExportView.vue" ),
            meta: { requiresAuth: true, authorization: permissions.trial_balance.exportCSV },
        },
        {
            path: "exchange-difference",
            component: () => import("../../views/accounting/ExchangeDifference.vue"),
            meta: { requiresAuth: true, authorization: permissions.period.closing},
        },
        {
            path: "retained-earning",
            component: () => import("../../views/accounting/RetainedEarningView.vue"),
            meta: { requiresAuth: true, authorization: permissions.period.closing},
        }
    ],
}